<template>
  <div>
    <van-tabs @click="onClick" v-model="activeName" color="#D5001C">
      <van-tab title="按经销商" name="1" v-if="isDealer != '1'">
        <div class="rank-list totol-rank">
          <div class="rank-list-item" v-for="(item, i) in rankList" :key="i">
            <div class="rank-name">
              <div class="rank-icon">
                <span>{{ i + 1 }}</span>
              </div>
              <span>{{ item.dealerName }}</span>
            </div>
            <div class="rank-num">{{ item.integral.toLocaleString('en-US') }}</div>
            <div class="rank-btn" @click="goDetail(item.dealerId)">详情<span> > </span></div>
          </div>
        </div>
        <van-pagination
          class="rank-page"
          v-model="pageNum"
          :total-items="total"
          :items-per-page="pageSize"
          mode="simple"
          @change="changePage"
        />
      </van-tab>
      <van-tab title="按学员" name="2">
        <div class="rank-list totol-rank">
          <div
            :class="{
              'rank-list-item': true,
              'is-turbo': item.type == 'turbo',
              'is-gts': item.type == 'gts',
            }"
            v-for="(item, i) in userList"
            :key="i"
          >
            <div class="rank-name">
              <div class="rank-icon">
                <span>{{ i + 1 }}</span>
              </div>
              <span class="user">{{ item.name }}</span>
              <van-image
                width="52"
                height="16"
                :src="require('../../assets/img/icon-' + item.passportName + '.png')"
              />
              <!-- <div class="rank-badge">
                <div v-for="(e, key) in item.userMapList" :key="key">
                  <van-image :src="e.img" width="15" height="13" />
                </div>
              </div> -->
            </div>
            <div class="rank-post">{{ item.postNameView }}</div>
            <div class="rank-num">{{ item.integral.toLocaleString('en-US') }}</div>
            <div class="rank-btn" @click="goDetail(item.ppn)">详情<span> > </span></div>
          </div>
        </div>
        <van-pagination
          class="rank-page"
          v-model="pageNumUser"
          :total-items="totalUser"
          :items-per-page="pageSizeUser"
          mode="simple"
          @change="changePageUser"
        />
      </van-tab>
    </van-tabs>
    <div class="back-btn" @click="$router.back()">返回</div>
  </div>
</template>

<script>
import { getDealerIntegral, getXyIntegral } from '@/api/common/index.js'
export default {
  name: 'totalRank',
  data() {
    return {
      activeName: '1',
      rankList: [],
      userList: [],
      dealerId: '',
      isDealer: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pageNumUser: 1,
      pageSizeUser: 10,
      totalUser: 0,
      userType: localStorage.getItem('userType'),
    }
  },
  // watch: {
  //   dealerId() {
  //     this.getRankList()
  //   },
  // },
  methods: {
    changePage(val) {
      this.pageNum = val
      this.getRankList()
    },
    changePageUser(val) {
      this.pageNumUser = val
      this.getUserList()
    },
    onClick(name) {
      this.activeName = name
      if (name == '1') {
        this.getRankList()
      } else if (name == '2') {
        this.getUserList()
      }
    },
    goDetail(id) {
      if (this.activeName == 1) {
        this.$router.push({
          path: '/dealerIndex',
          query: {
            id: id,
          },
        })
      } else if (this.activeName == 2) {
        this.$router.push({
          path: '/userIndex',
          query: {
            id: id,
          },
        })
      }
    },
    getUserList() {
      getXyIntegral(
        {
          companyId:
            this.userType == '0' ? JSON.parse(localStorage.getItem('user')).companyId : null,
          dealerId: this.userType == '1' || this.dealerId != null ? this.dealerId : null,
        },
        this.pageNumUser,
        this.pageSizeUser
      ).then((res) => {
        this.userList = res.rows
        this.totalUser = res.total
      })
    },
    getRankList() {
      getDealerIntegral(
        {
          companyId: JSON.parse(localStorage.getItem('user')).companyId,
          dealerId: this.dealerId,
        },
        this.pageNum,
        this.pageSize
      ).then((res) => {
        this.rankList = res.rows
        this.total = res.total
      })
    },
  },
  created() {},
  mounted() {
    this.dealerId = this.$route.query.id
    this.isDealer = this.$route.query.isDealer
    if (this.isDealer == '1') {
      this.activeName = '2'
      this.getUserList()
    }
    this.getRankList()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.totol-rank {
  margin: 10px 16px;
  background-color: #fff;
  border-radius: 4px;
  .rank-list-item {
    height: 44px;
    padding: 0 10px;
    &.is-turbo {
      background: url('../../assets/img/icon-Turbo.png') left top no-repeat;
      background-size: 22px;
    }
    &.is-gts {
      background: url('../../assets/img/icon-GTS.png') left top no-repeat;
      background-size: 22px;
    }
  }
}
.rank-page {
  margin: 10px 16px;
  .van-pagination__item {
    color: #d5001c;
  }
}
</style>
